<div *ngIf="!(isProduction$ | async) && (env$ | async) as envStr" class="ribbon"><a href="" >{{envStr}}</a></div>
